<!-- @format -->

<member-edit-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div
        class="modal__content_inner"
        if="{ props.member && props.member.user_info }"
      >
        <h2 class="heading-01 heading_edit">メンバー設定の編集</h2>

        <div class="container_user-account">
          <div class="user-account_name">
            <div class="user-account_name-icon">
              <img
                if="{ props.member.user_info.icon_path }"
                src="{ props.member.user_info.icon_path }"
                alt=""
              />
              <img
                if="{ !props.member.user_info.icon_path }"
                src="/assets/img/icon_default.svg"
                alt=""
              />
            </div>
            <p class="user">{ props.member.name }</p>
            <p class="user-account_role">
              { Role.get(props.member.role_id).name } / {
              props.member.user_info.group_name }
            </p>
          </div>
        </div>
        <!--/.container_user-account-->

        <form class="" name="form01" action="">
          <div class="container_input02">
            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="role">権限</label>
              <select
                name="role"
                id="role"
                class="sort-list"
                onchange="{ onRole }"
              >
                <option each="{ role in Role.roles() }" value="{ role.id }">
                  { role.name }
                </option>
              </select>
              <p class="notice">
                ※権限の詳細に関しては
                <a href="/menu/about-role">こちら</a>
              </p>
            </div>
            <!--/.wrap_input-->
            <div class="wrap_input wrap_input-60">
              <h3 class="form-heading">金額制限</h3>
              <div class="container_input">
                <input
                  id="yes"
                  type="radio"
                  name="limit"
                  value="limited"
                  class="radio_input js-limit-check"
                  onclick="{ onLimit }"
                />
                <label for="yes" class="radio_label">あり</label>
                <input
                  id="no"
                  type="radio"
                  name="limit"
                  value="infinity"
                  class="radio_input js-limit-check"
                  onclick="{ onLimit }"
                />
                <label for="no" class="radio_label">なし</label>
                <input
                  id="disabled"
                  type="radio"
                  name="limit"
                  value="nobudget"
                  class="radio_input js-limit-check"
                  onclick="{ onLimit }"
                />
                <label for="disabled" class="radio_label">決済不可</label>
              </div>
              <!--/.container_input-->

              <label class="form-heading" for="budget">制限する金額 / 月</label>
              <div class="container_input">
                <input
                  id="budget"
                  class="text_input limit_checked"
                  type="text"
                  name="budget"
                  is="binding"
                  data="{ state }"
                />
                <p>円</p>
              </div>
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->
        </form>

        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            value="キャンセル"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            onclick="{ change }"
          >
            設定の更新
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import Role from "@model/role.js";
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      state: {
        budget: null,
      },
      onBeforeMount(props, state) {
        this.Role = Role;
      },
      onBeforeShow() {
        this.update({
          role: this.props.member.role_id,
          budget: this.props.member.budget,
          limit: this.limitKind(this.props.member.budget),
        });
        this.$(
          `input[name="limit"][value="${this.state.limit}"]`
        ).checked = true;
        this.$(`input[name="budget"]`).disabled = (this.state.limit !== "limited");
      },
      onRole(e) {
        this.update({ role: e.target.value });
      },
      onLimit(e) {
        this.state.limit = e.target.value;
        this.$(`input[name="budget"]`).disabled = (e.target.value !== "limited");
      },
      onServiceRole(e) {
        this.state.service_role[e.target.name] = e.target.value;
        this.update({ services: this.state.service_role });
      },
      change(e) {
        this.props.onUpdateMember({
          bizid: this.props.member.bizid,
          role: this.state.role,
          budget: this.state.budget,
          limit: this.state.limit,
        });
      },
      limitKind(budget){
          if( budget === null){
              return "infinity"
          }else if( budget > 0){
              return "limited"
          }else{
              return "nobudget"
          }
      },
    };
  </script>
</member-edit-modal>
